<nav [attr.aria-label]="label">
  <div class="tabs">
    @for (item of items; track item.id) {
      <button
        type="button"
        [attr.aria-current]="isActive(item.id) ? 'page' : null"
        (click)="selected.emit(item.id)"
      >
        <span class="pill" aria-hidden="true">
          <!--
          Same family as the support screen's impact icons: stroke only, 24px grid, 1.5px, and the
          colour taken from the button so the active pill inverts them for free.
        -->
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            @switch (item.icon) {
              @case ('wishes') {
                <!-- A calame: the reed pen, with the ink stroke it has just laid down. -->
                <path d="M4.8 19.2c1.3-5.9 5.3-12.3 14.6-15.1C16.6 13.4 10.7 17.9 4.8 19.2Z" />
                <path d="M4.8 19.2 11.4 12.6" />
              }
              @case ('wasi') {
                <!-- A person: the one trusted with the rest. -->
                <circle cx="12" cy="8.4" r="3.4" />
                <path d="M5.4 19.2c.6-3.6 3.3-5.6 6.6-5.6s6 2 6.6 5.6" />
              }
              @case ('settings') {
                <!-- A gear: the one shape every app agrees on. -->
                <circle cx="12" cy="12" r="3.1" />
                <path
                  d="M19.4 12a7.4 7.4 0 0 0-.1-1.2l2-1.5-1.9-3.3-2.4.9a7.4 7.4 0 0 0-2-1.2L14.6 3h-3.8l-.4 2.7a7.4 7.4 0 0 0-2 1.2l-2.4-.9L4.1 9.3l2 1.5a7.4 7.4 0 0 0 0 2.4l-2 1.5 1.9 3.3 2.4-.9a7.4 7.4 0 0 0 2 1.2l.4 2.7h3.8l.4-2.7a7.4 7.4 0 0 0 2-1.2l2.4.9 1.9-3.3-2-1.5c.07-.4.1-.8.1-1.2Z"
                />
              }
              @case ('documents') {
                <!-- A sheet with its corner folded back. -->
                <path
                  d="M13.9 3.4H7.4A1.9 1.9 0 0 0 5.5 5.3v13.4a1.9 1.9 0 0 0 1.9 1.9h9.2a1.9 1.9 0 0 0 1.9-1.9V7.9Z"
                />
                <path d="M13.9 3.4v4.5h4.6" />
              }
            }
          </svg>
        </span>
        <span class="label">{{ item.label }}</span>
      </button>
    }
  </div>

  @if (moreLabel) {
    <button
      type="button"
      class="more"
      [attr.aria-label]="moreLabel"
      [attr.aria-current]="moreActive ? 'page' : null"
      (click)="moreSelected.emit()"
    >
      <span aria-hidden="true">⋯</span>
    </button>
  }
</nav>
